import * as base64 from 'base64-arraybuffer';
import pako from 'pako';
var arrayToString = function (array) {
    var str = '';
    for (var i = 0; i < array.length; i++) {
        str += String.fromCharCode(array[i]);
    }
    return str;
};
export var decompressJson = function (compressedJson) {
    return arrayToString(pako.inflate(base64.decode(compressedJson)));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@pdf-lib/standard-fonts/es/utils.js
// module id = null
// module chunks = 